import React, { useEffect, useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import ButtonYesno from "../../../components/buttons/button.yesno.js";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import SelectDepartement from "../../../components/selects/select.departement";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import PrimoAccedant from "../../../components/questions/PrimoAccedant";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires.js";
import {useSnackbar} from "notistack";
import Promesse from "../../../components/questions/Promesse.js";
import Pret from "../../../components/questions/Pret.js";

// Vente d'immeuble hors copropriété ou de locaux bâtis affectés à tous usages, régime DMTO - hors champs de TVA, selon le département
// simulateur id 1

function Simulateur_A1_1(props) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [departement, setDepartement] = useState(0);
  const [departementChiffre, setDepartementChiffre] = useState(0);
  const [promesse, setPromesse] = useState(0);
  const [acteEnMain, setActeEnMain] = useState(0);
  const [pretHypo, setPretHypo] = useState(0);
  const [pretsPro, setPretsPro] = useState(0);
  const [simu84, setSimu84] = useState(null);
  const currentIdSimu = 1;
  const [simuA112PRO, setSimuA112PRO] = useState(null);
  const [cautionSansGarantieHypo, setCautionSansGarantieHypo] = useState(0);
  const [simu114, setSimu114] = useState(null);
  const [montantVente, setMontantVente] = useState(0);
  const [montantMeuble, setMontantMeuble] = useState(0);
  const [montantPrimoAccedant, setMontantPrimoAccedant] = useState(0);
  const [montantPromesse, setMontantPromesse] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [taxeIleDeFrance, setTaxeIleDeFrance] = useState(0);
  const [zrr, setZrr] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
  const [primoAccedant, setPrimoAccedant] = useState(0);

  const [dependances, setDependancesState] = useState([]);

const handleChange = async (setter, value, key) => {
    if (key === "montant_primo_accedant") {
      if (parseInt(value) >= parseInt(montantVente)) {
        enqueueSnackbar('Le montant ne peut être supérieur au montant total de la vente, ' + montantVente.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €', {
          variant: 'warning'
        });
        value = parseInt(montantVente);
      }
    }

    if (setter === setDepartementChiffre) {
      if (!props.depsPrimoAccedants.includes(value)) {
        setPrimoAccedant(0);
      }
      setDepartementChiffre(value);
    } else {
      setter(value);
      setInRedux(setter, value, key);
    }
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  useEffect(() => {
    if (simu84 !== undefined && simu84 !== null) setDependances(simu84);
  }, [simu84]);

  useEffect(() => {
    if (simuA112PRO !== undefined && simuA112PRO !== null) setDependances(simuA112PRO);
  }, [simuA112PRO]);

  useEffect(() => {
    if (simu114 !== undefined && simu114 !== null) setDependances(simu114);
  }, [simu114]);

  // useEffect(() => {
  //     localStorage.setItem("remarque", remarque)
  // }, [remarque]);

  function setDependances(simu) {
    setInRedux("dependance", simu);
  }

  function setInRedux(setter, value, key) {
    let object = {
      simulateurid: currentIdSimu,
      departementid: parseInt(departement),
      inputs: {
        montant_vente: parseInt(montantVente),
        montant_meuble: parseInt(montantMeuble),
        montant_primo_accedant: parseInt(montantPrimoAccedant),
        montant_promesse: parseInt(montantPromesse),
        montant_deb_add: parseInt(montantDeboursAdditionnels),
        taxe_ile_de_france: parseInt(taxeIleDeFrance),
        debours_additionnels: parseInt(deboursAdditionnels),
        zrr: parseInt(zrr),
        promesse: parseInt(promesse),
        acte_en_main: parseInt(acteEnMain),
        pretsPro: parseInt(pretsPro),
        primo_accedant: parseInt(primoAccedant),
        convention_honoraires : parseInt(props.conventionHonoraires),
      },
      pdfInputs: {
        nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
        object_convention_honoraires : props.objectConventionHonoraires,
        montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
        nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
        adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
      },
      dependances: dependances,
    };
    //For values coming from components
    if (key) {
      if (key === "primo_accedant") {
        if (value === 0) {
          setMontantPrimoAccedant(0)
          Object.assign(object["inputs"], { montant_primo_accedant: parseInt(0) });
        }
        Object.assign(object["inputs"], { primo_accedant: parseInt(value) });
      }
      if (key === "promesse") {
        if (value === 0) {
          setMontantPromesse(0)
          Object.assign(object["inputs"], { montant_promesse: parseInt(0) });
        }
        Object.assign(object["inputs"], { promesse: parseInt(value) });
      }
      if (key === "montant_primo_accedant") { Object.assign(object["inputs"], { montant_primo_accedant: parseInt(value) }); }
      if (key === "montant_promesse") { Object.assign(object["inputs"], { montant_promesse: parseInt(value) }); }
    }
    //For internal settings
    if (setter === setPretHypo && value === 0) {
      setSimu84(null);
      setSimuA112PRO(null);
      setDependancesState([]);
      object.dependances = [];
    }

    if (setter === setPretsPro && value === 0) {
      setSimu84(null);
      setDependancesState([]);
      object.dependances = [];
    } else if (setter === setPretsPro && value === 1) {
      setSimuA112PRO(null);
      setDependancesState([]);
      object.dependances = [];
    }
    
    if( setter === setCautionSansGarantieHypo && value === 1) {
      setPretHypo(0);
      setPretsPro(0);
      setSimu84(null);
      setSimuA112PRO(null);
      setDependancesState([]);
      object.dependances = [];
    }

    if (setter === setCautionSansGarantieHypo && value === 0) {
      setSimu114(null);
      setDependancesState([]);
      object.dependances = [];
    }

    if (setter === "dependance") {
      if (dependances.length > 0) object.dependances = dependances;

      if (value !== undefined) {
        let validator = false;

        for (let i = 0; i < object["dependances"].length; i++) {
          if (object["dependances"][i]?.simulateurid === value.simulateurid) {
            object.dependances[i] = value;
            validator = true;
          }
        }

        if (validator === false) {
          object.dependances.push(value);
        }

        setDependancesState(object.dependances);
      }
    }

    if (setter === setMontantVente) { Object.assign(object["inputs"], { montant_vente: parseInt(value) }); }
    if (setter === setMontantMeuble) { Object.assign(object["inputs"], { montant_meuble: parseInt(value) }); }
    if (setter === setMontantDeboursAdditionnels) { Object.assign(object["inputs"], { montant_deb_add: parseInt(value) }); }
    if (setter === setDepartement) { object.departementid = parseInt(value); }
    if (setter === setTaxeIleDeFrance) { Object.assign(object["inputs"], { taxe_ile_de_france: parseInt(value) }); }
    if (setter === setZrr) { Object.assign(object["inputs"], { zrr: parseInt(value) }); }
    if (setter === setDeboursAdditionnels) { Object.assign(object["inputs"], { debours_additionnels: parseInt(value) }); }
    if (setter === setActeEnMain) { Object.assign(object["inputs"], { acte_en_main: parseInt(value) }); }

    if (setter === props.setConventionHonoraires) {
      if(value === 0){
        props.setNombreConventionHonoraires(1);
        props.setObjectConventionHonoraires(null);
        props.setMontantConventionHonoraires(null);
        props.setNomSignataireConventionHonoraires(null);
        props.setAdresseSignataireConventionHonoraires(null);
        Object.assign(
          object["inputs"], { convention_honoraires : parseInt(value) },
          object["pdfInputs"], {
            nombre_convention_honoraires : null,
            object_convention_honoraires : null,
            montant_convention_honoraires : null,
            nom_signataire_convention_honoraires : null,
            adresse_signataire_convention_honoraires : null
          },
        );
      } else {
        Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
      }
    }

    if (setter === props.setNombreConventionHonoraires) { Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) }); }
    if (setter === props.setObjectConventionHonoraires) { Object.assign(object["pdfInputs"], { object_convention_honoraires : value }); }
    if (setter === props.setMontantConventionHonoraires) { Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)}); }
    if (setter === props.setNomSignataireConventionHonoraires) { Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value }); }
    if (setter === props.setAdresseSignataireConventionHonoraires) { Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value }); }

    if (props.isParent) {
      dispatch(setSimulateurObject(object));
    } else {
    }
  }

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>
          Pour la vente, acte tarifé au titre du Tableau 5, n° 54 (Art A444-91). Prêt aux particuliers associé acte
          tarifé au titre du Tableau 5, n° 137 (Art A444-143). Prêt aux professionnels associé acte tarifé au titre du
          Tableau 5, n° 128 (Art A444-139). Cautionnement associé acte tarifé au titre du Tableau 5, n° 111 (Art
          A444-127).
        </p>

        {props?.isParent === true && props.departements !== "" ? (
          <>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Département :</div>

              <SelectDepartement
                items={props.departements}
                nameField={"name"}
                defaultValue={currUserDep}
                optionValue={"id"}
                handleChange={handleChange}
                setter={setDepartement}
                setDepartementChiffre={setDepartementChiffre}
              />
            </div>
            <div style={styles.cardRowSpecialMessage}>
              La taxe départementale utilisée pour vos calculs est bien celle qui a été votée dans votre département. Attention de bien penser à indiquer le bon département lorsque vous effectuez une vente sur un département qui n’est pas le votre.
            </div>
          </>
        ) : (
          <></>
        )}

        {props.depsTaxeIleFrance.includes(departement) ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Mutation soumise à la taxe additionnelle de 0.6% selon l'article 1599 sexies du CGI ?
              <ToolTipPerso
                title={
                  "Attention : Cette taxe ne s’applique que dans certains cas. Se référer au texte en vigueur qui les précise : art 1599 sexies du CGI. \n" +
                  "Taxe additionnelle aux droits d'enregistrement ou à la taxe de publicité foncière exigible sur les mutations à titre onéreux de locaux mentionnés à l'article L. 520-1 du code de l'urbanisme et situés en IDF. \n" +
                  "Le taux de la taxe est fixé à 0,6 %. \n" +
                  "Cette taxe s’applique aux :\n" +
                  " - locaux à usage de bureaux ;\n" +
                  " - locaux commerciaux ;\n" +
                  " - locaux de stockage. \n" +
                  "Cette taxe ne s'applique pas :\n" +
                  " - aux mutations à titre onéreux soumises à la taxe sur la valeur ajoutée ;\n" +
                  " - aux mutations exonérées de droits d'enregistrement ou de taxe de publicité foncière ;\n" +
                  " - aux mutations d'immeubles sis hors de la région d'Île-de-France, y compris lorsque les actes translatifs de ces propriétés sont soumis à la formalité de l'enregistrement en Île-de-France ;\n" +
                  " - aux opérations qui ne constituent pas une vente ou une opération assimilée."
                }
              />
            </div>
            <div>
              <ButtonYesno
                handleChange={handleChange}
                setter={setTaxeIleDeFrance}
                fieldUndefined={false}
                defaultValue={0}
              />
            </div>
          </div>
        ) : (
          <>
            {props.depsZrr.includes(departement) ? (
              <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                  Habitation située dans une zone de revitalisation rurale ? (faisant l'objet d'une réduction de droits)
                </div>
                <div>
                  <ButtonYesno handleChange={handleChange} setter={setZrr} fieldUndefined={false} defaultValue={0} />
                </div>
              </div>
            ) : (
              <></>
            )}
          </>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>La vente est-elle consentie "Acte en main" ?</div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setActeEnMain} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>

        <div className="cardRow">
          {acteEnMain === 0 ? (
            <div style={styles.cardElemVerticalyCenter}>Quel est le montant total de la vente ?</div>
          ) : (
            <div style={styles.cardElemVerticalyCenter}>Quel est le montant de la vente "acte en main" ?</div>
          )}

          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantVente}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Quel est le montant des meubles (y compris) ?</div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantMeuble}
          />
        </div>

        {props.depsPrimoAccedants.includes(departementChiffre) ? (
            <PrimoAccedant
                handleChange={handleChange}
                setPrimoAccedant={setPrimoAccedant}
                primoAccedant={primoAccedant}
                setMontantPrimoAccedant={setMontantPrimoAccedant}
                maxPrimo={montantVente}
            />
        ) : (
            <></>
        )}

        <Promesse
          handleChange={handleChange}
          setPromesse={setPromesse}
          promesse={promesse}
          setMontantPromesse={setMontantPromesse}
        />

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Y a-t-il des débours additionnels à prévoir ?
            <ToolTipPerso
                title={
                  "Les débours sur les ventes comprennent une somme de 120 euros représentant le coût moyen d'obtention d'un certificat d'urbanisme complet. Pour retirer ce coût, répondre 'non' à la question."
                }
            />
          </div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setDeboursAdditionnels} fieldUndefined={true} defaultValue={2} />
          </div>
        </div>

        {parseInt(deboursAdditionnels) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Montant des débours additionnels :</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantDeboursAdditionnels}
            />
          </div>
        ) : (
          <></>
        )}

        <Pret
            pretHypo={pretHypo}
            setPretHypo={setPretHypo}
            pretsPro={pretsPro}
            setPretsPro={setPretsPro}
            withPretsProChoice={true}
            setSimu84={setSimu84}
            setSimu92={setSimuA112PRO}
            cautionSansGarantieHypo={cautionSansGarantieHypo}
            setCautionSansGarantieHypo={setCautionSansGarantieHypo}
            setSimu114={setSimu114}
            simulateur={props.simulateur}
            departementId={departement}
            handleChange={handleChange}
        />

        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_A1_1;
